import React, { PureComponent, Fragment } from 'react';
import MuiAvatar from '@material-ui/core/Avatar';
import styled, { css } from 'styled-components';
import { colors } from '../../../constants/colors';
import { fontSize, fontFamily } from '../../../constants/text';

const Avatar = styled(MuiAvatar)<{ $backgroundColor?: string; $size: string | number }>`
  color: ${colors.theWhiteAlbum};
  font-size: ${fontSize.default};
  font-family: ${fontFamily.medium};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  text-align: center;
  ${(props) => css`
    background-color: ${props.$backgroundColor};
    border-radius: 50%;
    height: ${props.$size}px;
    line-height: ${props.$size}px;
    width: ${props.$size}px;
  `};
`;

type OwnProps = {
  handleClick?: (...args: any[]) => any;
  backgroundColor?: string;
  src?: string;
  className?: string;
  size?: number;
};

type Props = OwnProps & typeof Circle.defaultProps;

class Circle extends PureComponent<Props> {
  static defaultProps = {
    size: 40,
  };

  render = () => {
    const { handleClick, backgroundColor, src, className, size } = this.props;
    return (
      <Avatar
        $backgroundColor={backgroundColor}
        $size={size}
        className={className}
        onClick={handleClick}
        src={src}
      >
        {this.props.children}
      </Avatar>
    );
  };
}

export default Circle;
